import React, { useEffect, useState } from 'react'
import TextField from "@material-ui/core/TextField";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { getallReguser } from "../../features/Registration/registrationSlice";
import { Spinners } from "../TableOptions";
import { reset, UpdateOffer } from "../../features/Applicant/applicantSlice";
import swal from 'sweetalert';
import { useNavigate } from "react-router-dom";
import { OfferStatus } from '../JobInputData';
import ModalHeader from '../ModalHeader';

const UpdateOfferModal = ({ id, name, disabled, offer }) => {



	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { UpdateOfferisError, UpdateOffermessage, UpdateOfferisLoading, UpdateOfferisSuccess } = useAppSelector((state: { applicant: any; }) => state.applicant)


	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);


	useEffect(() => {
		dispatch(getallReguser());
	}, [dispatch]);

	const [inputs, setInputs] = useState({
		status: "",
		comment: "",
	});





	useEffect(() => {
		if (UpdateOfferisError) {
			swal({
				title: "error",
				text: UpdateOffermessage,
				icon: "error"
			})
		} else if (UpdateOfferisSuccess) {
			swal({
				title: "success",
				text: "Offer Updated!",
				icon: "success"
			})
			setShow(false)
			setInputs(
				{
					status: "",
					comment: "",
				}
			)
		}
		dispatch(reset())
	}, [UpdateOfferisError, UpdateOfferisSuccess, UpdateOffermessage, dispatch, navigate])



	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};



	const handleSendOffer = () => {
		const input = { inputs, id }
		// @ts-ignore
		dispatch(UpdateOffer(input));
	}

	return (
		<>
			<Button onClick={() => setShow(true)} className={disabled ? "view-job-profile more-button-disabled" : "view-job-profile update"}>
				{disabled ? offer : "Update Offer"}
			</Button>
			<Modal show={show} onHide={handleClose}>
				<ModalHeader setShow={setShow} headerTitle={"Update Offer"} />
				<Modal.Body>
					<form>
						<div className="applicant-name">
							<h5>Applicant Name</h5>
							<p>{name}</p>
						</div>
						<br />
						<div className="reviewer-name">
							<h6>Offer Status</h6>
							<select
								className="round"
								onChange={(e) => handleOnChange("status", e.target.value)}
							>

								<option>Select Offer Status</option>
								{OfferStatus?.map((item: any) => (
									<option key={item} value={item} >
										{item}
									</option>
								))}
							</select>

							<div className="comment mt-4">
								<h6>Comment</h6>
								<TextField
									id="outlined-multiline-static"
									multiline
									fullWidth
									type="text"
									minRows={4}
									variant="outlined"
									style={{ margin: "10px 0" }}
									value={inputs.comment}
									onChange={(e) => handleOnChange("comment", e.target.value)}
								/>
							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Cancel
					</Button>
					<Button id="primary" onClick={handleSendOffer}>
						{UpdateOfferisLoading ? <Spinners size={"sm"} /> : 'Send'}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default UpdateOfferModal
